/* unplugin-vue-components disabled */import script from "./translations.vue?vue&type=script&lang=js"
export * from "./translations.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__